import { render } from "./AuditsPanel.vue?vue&type=template&id=784b7ca4&scoped=true"
import script from "./AuditsPanel.vue?vue&type=script&lang=js"
export * from "./AuditsPanel.vue?vue&type=script&lang=js"

import "./AuditsPanel.vue?vue&type=style&index=0&id=784b7ca4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-784b7ca4"]])

export default __exports__